export default "__VITE_ASSET__B37bldM6__"